/**
 * Convert a value that may contain AACChromeAPI class instances into plain,
 * serializable data for the Redux store.
 *
 * AACChromeAPI models configuration as classes: `ChromeConfiguration` holds
 * `MarketplaceSwitcher`, `PivotNav` and `PageHeader` values, each extending
 * `BaseClass`. Redux requires plain values, so an instance in the store fails
 * RTK's `serializableCheck` and defeats state serialization.
 *
 * Passing one straight to a reducer is not caught by the spread: reducers spread
 * their payload, which flattens only the top level, so a nested instance
 * survives. Dispatching a `ChromeConfiguration` is how
 * `shared.chromeConfig.marketplaceSwitcher` came to hold a `MarketplaceSwitcher`
 * rather than the `{ useMarketplaceSwitcher, marketplacePath }` its type claims.
 *
 * A JSON round-trip is sufficient because the API classes keep their data in own
 * enumerable properties named exactly as the store's interfaces declare them
 * (`useMarketplaceSwitcher`, `marketplacePath`, ...). Only the prototype
 * accessors and any registered callbacks are dropped, and those are owned and
 * invoked by AACChromeAPI — no reducer or selector reads them back out of Redux.
 *
 * The parameter is `object` rather than `unknown` so that `undefined`, which
 * would make `JSON.parse` throw, cannot reach it.
 */
export const toPlainData = <TPlain>(value: object): TPlain =>
  JSON.parse(JSON.stringify(value)) as TPlain;
